export const FUNC_RETURN_NULL = () => null;
export const DEFAULT = 'default';
